const constants = {
    BEDTIME_SHOW: 'BEDTIME_SHOW',
    BEDTIME_START_HOUR: 'BEDTIME_START_HOUR',
    BEDTIME_START_MINUTE: 'BEDTIME_START_MINUTE',
    BEDTIME_START_AMPM: 'BEDTIME_START_AMPM',
    BEDTIME_END_HOUR: 'BEDTIME_END_HOUR',
    BEDTIME_END_MINUTE: 'BEDTIME_END_MINUTE',
    BEDTIME_END_AMPM: 'BEDTIME_END_AMPM',
    TIMER_SHOW: 'TIMER_SHOW',
    TIMER_START_MINUTE: 'TIMER_START_MINUTE',
    TIMER_END_TIME_IN_SECONDS: 'TIMER_END_TIME_IN_SECONDS',
    SETTINGS: 'SETTINGS',
    CLOCK_NUMBER_COLORS: ['#007eb7', '#c64fa9', '#0e276f', '#167211', '#a24514', '#590008', '#007eb7', '#c64fa9', '#0e276f', '#167211', '#a24514', '#590008'],
    EVENTS_SHOW: 'EVENTS_SHOW',
    EVENTS: 'EVENTS'
};

module.exports = constants;